import { Event } from '@/event-bus/event';

export class DrawerOpenEvent extends Event<void> {}
